"use strict";
// Fase 17.3, Plano 04 — RT-01/RT-02/RT-09: importação dos roteiros do CargaMáquina (prévia, confirmação, histórico).
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=roteiros-importacao.js.map